import { Component } from "@angular/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";

export interface RadioButtonOption {
    label: string;
    value: any;
    disabled?: boolean;
}

export interface RadioButtonCellRendererParams {
    field: string;
    options: RadioButtonOption[];
    onValueChange?: (rowData: any, newValue: any) => void;
    onDisabledClick?: (option: RadioButtonOption) => void;
}

@Component({
    selector: "radio-button-cell-renderer",
    templateUrl: "./radio-button-cell-renderer.component.html",
    standalone: false
})
export class RadioButtonCellRendererComponent implements ICellRendererAngularComp {
    params: any;
    options: RadioButtonOption[] = [];
    selectedValue: any;
    field: string;
    radioGroupName: string;

    agInit(params: ICellRendererParams): void {
        this.params = params;
        this.refresh(params);
    }

    refresh(params: ICellRendererParams): boolean {
        this.params = params;
        const customParams = params as any as RadioButtonCellRendererParams;
        this.field = customParams.field || 'value';
        this.options = customParams.options || [];
        this.selectedValue = params.data?.[this.field] || (this.options.length > 0 ? this.options[0].value : null);
        this.radioGroupName = `radio-${this.field}-${params.data?.sequence ?? (params as any).rowIndex ?? Math.random()}`;
        return true;
    }

    onValueChange(value: any): void {
        this.selectedValue = value;
        if (this.params.data) {
            this.params.data[this.field] = value;
        }
        const callback = (this.params as any).onValueChange;
        if (callback instanceof Function) {
            callback(this.params.data, value);
        }
    }

    onDisabledOptionClick(option: RadioButtonOption): void {
        if (option.disabled) {
            const callback = (this.params as any).onDisabledClick;
            if (callback instanceof Function) {
                callback(option);
            }
        }
    }
}
